import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import './style.scss';

function CustomScrollbars(props) {

    return (
        <Scrollbars
            renderTrackHorizontal={props => <div {...props} className="track-horizontal" />}
            renderTrackVertical={props => <div {...props} className="track-vertical" />}
            renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" />}
            renderThumbVertical={props => <div {...props} className="thumb-vertical" />}
            renderView={props => <div {...props} className="view" />}
            autoHeight={props.autoHeight}
            autoHeightMin={props.autoHeightMin}
            autoHeightMax={props.autoHeightMax}
            autoHide={props.autoHide}
            onScroll={props.onScroll && props.onScroll}
            onUpdate={props.onUpdate && props.onUpdate}
            style={props.style && props.style}
            ref={props.refa && props.refa}

        >
            {props.children}
        </ Scrollbars>
    )
}

export default CustomScrollbars
